import {
  complement,
  curry,
  isEmpty,
  isNil,
  lensPath,
  lensProp,
  pipe,
  set,
  view,
} from "ramda";

export const initialStepState = {
  completed: false,
  loadingLocalStorage: true,
  errors: {},
  fields: {},
};

export const completedLens = lensProp("completed");
export const setCompleted = set(completedLens);
export const getCompleted = view(completedLens);

export const loadingLocalStorageLens = lensProp("loadingLocalStorage");
export const setLoadingLocalStorage = set(loadingLocalStorageLens);
export const getLoadingLocalStorage = view(loadingLocalStorageLens);

export const errorsLens = lensProp("errors");
export const setErrors = set(errorsLens);
export const getErrors = view(errorsLens);
export const hasErrors = pipe(getErrors, complement(isEmpty));

export const fieldsLens = lensProp("fields");
export const setFields = set(fieldsLens);
export const getFields = view(fieldsLens);
export const getField = curry((path, state) =>
  view(lensPath(["fields", ...path]), state)
);
export const setField = curry((path, value, state) =>
  set(lensPath(["fields", ...path]), value, state)
);

export const completeStep = (validator, state) => {
  const fields = getFields(state);
  const errors = fields.isSubmitterCreator ? {} : validator(fields);

  return pipe(
    setErrors(isNil(errors) ? {} : errors),
    setCompleted(isNil(errors) || isEmpty(errors))
  )(state);
};
